module.exports = {
    smp: '(max-width: 768px)',
    tablet: '(max-width: 1024px)',
    pc: '(min-width: 769px)'
};


//////////////////
// WEBPACK FOOTER
// ./assets/js/_module/mq.js
// module id = 1
// module chunks = 0 1